import { HTTP_REQUEST_METHODS } from '@js/constants/js-constants.es6.js';
import HttpClient from "@js/helpers/http-client.es6.js";

export default class LuminisHttpClient extends HttpClient {
  constructor(basePath) {
    if (!basePath) {
      basePath = drupalSettings?.luminis?.oauthRestUrl + '/';
    }
    super(basePath);
    this.basePath = basePath;
  }

  async get({ relativePath, headers = {}, cache = 'no-cache' }, errorMessage, errorRedirectPage, successRedirectPage, handleErrorElsewhere = false) {
    const method = HTTP_REQUEST_METHODS.GET;
    const options = {
      method,
      relativePath: relativePath,
      headers,
      cache
    };

    const response = await super.get(options, errorMessage, errorRedirectPage, successRedirectPage, handleErrorElsewhere);

    if (handleErrorElsewhere) {
      return response;
    }
    return response?.result;
  }

  async postJson({
    relativePath,
    body = {},
    headers = {},
    cache = 'no-cache',
  }, errorMessage, errorRedirectPage, successRedirectPage, handleErrorElsewhere = false) {
    const method = HTTP_REQUEST_METHODS.POST;
    headers['Content-Type'] = 'application/json';

    const options = {
      method,
      relativePath: relativePath,
      body,
      headers,
      cache,
    };

    const response = await super.postJson(options, errorMessage, errorRedirectPage, successRedirectPage, handleErrorElsewhere);
    if (handleErrorElsewhere) {
      return response;
    }
    return response?.result;
  }

  async postFormData({
    relativePath,
    body = {},
    headers = {},
    cache = 'no-cache',
  }, errorMessage, errorRedirectPage, successRedirectPage, handleErrorElsewhere = false) {
    const method = HTTP_REQUEST_METHODS.POST;
    headers['Content-Type'] = 'application/json';

    const options = {
      method,
      relativePath: relativePath,
      body,
      headers,
      cache,
    };

    const response = await super.postFormData(options, errorMessage, errorRedirectPage, successRedirectPage, handleErrorElsewhere);
    if (handleErrorElsewhere) {
      return response;
    }
    return response?.result;
  }

  async putJson({ relativePath, body = {}, headers = {}, cache = 'no-cache' }, errorMessage, errorRedirectPage, successRedirectPage, handleErrorElsewhere = false) {
    const method = HTTP_REQUEST_METHODS.PUT;
    headers['Content-Type'] = 'application/json';

    const options = {
      method,
      relativePath: relativePath,
      body,
      headers,
      cache,
    };

    return await super.putJson(options, errorMessage, errorRedirectPage, successRedirectPage, handleErrorElsewhere);
  }

  async putFormData({
    relativePath,
    body = {},
    headers = {},
    cache = 'no-cache',
  }, errorMessage, errorRedirectPage, successRedirectPage, handleErrorElsewhere = false) {
    const method = HTTP_REQUEST_METHODS.PUT;
    headers['Content-Type'] = 'application/json';

    const options = {
      method,
      relativePath: relativePath,
      body,
      headers,
      cache,
    };

    const response = await super.putFormData(options, errorMessage, errorRedirectPage, successRedirectPage, handleErrorElsewhere);
    if (handleErrorElsewhere) {
      return response;
    }
    return response?.result;
  }

  async delete({ relativePath, headers = {}, cache = 'no-cache' }, errorMessage, errorRedirectPage, successRedirectPage, handleErrorElsewhere = false) {
    const method = HTTP_REQUEST_METHODS.DELETE;

    const options = {
      method,
      relativePath: relativePath,
      headers,
      cache,
    };

    const response = await super.delete(options, errorMessage, errorRedirectPage, successRedirectPage, handleErrorElsewhere);
    if (handleErrorElsewhere) {
      return response;
    }
    return response?.result;
  }

  static getCookieValue(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2)
      return parts
        .pop()
        .split(';')
        .shift();
  }

  /*
    Redirect to a luminis api URL in order to handle 301 redirects properly.
   */
  redirect(pathToRedirectTo) {
    window.location = this.basePath + pathToRedirectTo;
  }
}
